import React from 'react'

const CalendarMonthFoldedIcon = () => {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M7.5 11.053H5V12.303H7.5V11.053Z' fill='#141424' />
      <path d='M5 14.178H7.5V15.428H5V14.178Z' fill='#141424' />
      <path d='M11.25 11.053H8.75V12.303H11.25V11.053Z' fill='#141424' />
      <path d='M12.5 11.053H15V12.303H12.5V11.053Z' fill='#141424' />
      <path d='M11.25 14.178H8.75V15.428H11.25V14.178Z' fill='#141424' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.875 4.17798H5.625V2.30298H6.875V4.17798H13.125V2.30298H14.375V4.17798H18.125V12.928C18.125 16.0346 15.6066 18.553 12.5 18.553H1.875V4.17798ZM5.625 5.42798V6.67798H6.875V5.42798H13.125V6.67798H14.375V5.42798H16.875V7.92798L3.125 7.92798V5.42798H5.625ZM3.125 9.17798L16.875 9.17798V12.928C16.875 13.1402 16.8599 13.3489 16.8307 13.553H13.125V17.2587C12.9209 17.2879 12.7122 17.303 12.5 17.303H3.125V9.17798ZM14.375 14.803H16.454C16.0218 15.7128 15.2848 16.4498 14.375 16.882V14.803Z'
        fill='#141424'
      />
    </svg>
  )
}

export default CalendarMonthFoldedIcon
